module.exports = __webpack_public_path__ + "media/images/icons/profile-frame-aad00028e19744e8599f7c78a5d28a3f.svg";